import { Link } from 'react-router-dom';
import { installAppUpdate, remindLater, useAppUpdate } from '../lib/appUpdate';
import { androidAppInstallsUpdates } from '../lib/native';

/** Inside the Android app: a newer app is on the server (see lib/appUpdate.ts). */
export function AppUpdateBar() {
  const { available, state, message } = useAppUpdate();
  if (!available) return null;
  const v = available.versionName;
  const button = (label: string) => (
    <button type="button" onClick={installAppUpdate} className="font-semibold underline">
      {label}
    </button>
  );
  let body;
  if (state === 'downloading')
    body = androidAppInstallsUpdates()
      ? `Downloading Comms ${v}…`
      : `Downloading Comms ${v}. When it's done, tap the download to install it.`;
  else if (state === 'installing') body = `Follow Android's prompt to install Comms ${v}.`;
  else if (state === 'needs-permission')
    body = (
      <>
        Allow Comms to install apps in the settings that opened, then come back. {button('Update')}
      </>
    );
  else if (state === 'failed')
    body = (
      <>
        {message ?? "The update didn't work."} {button('Try again')}
      </>
    );
  else
    body = (
      <>
        Comms {v} is available.
        <Link to="/android" className="underline">
          What&apos;s new
        </Link>
        {button('Update')}
      </>
    );
  return (
    <div
      role="status"
      data-app-update
      className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-accent px-4 py-1 text-sm text-white"
    >
      {body}
      {state !== 'downloading' && state !== 'installing' && (
        <button
          type="button"
          onClick={() => remindLater(available.versionCode)}
          className="text-white/80 underline"
        >
          Later
        </button>
      )}
    </div>
  );
}
